var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilingOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D6D"
    },
    d: "M484.8,0H287.2c-6.4,0-12,0-18.4,9.6L258.4,24H24.8C11.2,24,0,38.4,0,52v314.4 C0,380,11.2,392,24.8,392h446.4c13.6,0,24.8-12,24.8-26.4V122.4V52V11.2C496,4.8,491.2,0,484.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656"
    },
    d: "M485.6,324c6.4-4,10.4-12,10.4-20V122.4V52V11.2C496,4.8,491.2,0,484.8,0H287.2c-6.4,0-12,0-18.4,9.6 L258.4,24H24.8C12,24,1.6,35.2,0,47.2L485.6,324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262523"
    },
    d: "M16,56l469.6,269.6c6.4-4,10.4-13.6,10.4-21.6V122.4V77.6L465.6,56H16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 56,
    style: {
      fill: "#FFFFFF"
    },
    width: 416,
    height: 304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 56,
    style: {
      fill: "#EFEFEF"
    },
    width: 200,
    height: 304
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A5"
    },
    d: "M496,376c0,13.6-11.2,24-24.8,24H24.8C11.2,400,0,390.4,0,376l8-249.6C8,112.8,19.2,104,32.8,104H464 c13.6,0,24.8,8.8,24.8,22.4L496,376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B7B7"
    },
    d: "M492.8,388.8L11.2,115.2c-1.6,2.4-3.2,6.4-3.2,9.6L0,376c0,13.6,11.2,24,24.8,24h446.4 C480,400,488,396,492.8,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#9AA5A4",
      enableBackground: "new"
    },
    d: "M496,388.8C496,448,448,496,388.8,496s-107.2-48-107.2-107.2 s48-107.2,107.2-107.2S496,329.6,496,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F4F4F"
    },
    d: "M482.4,388.8c0,59.2-48,107.2-107.2,107.2S268,448,268,388.8s48-107.2,107.2-107.2 C434.4,281.6,482.4,329.6,482.4,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262523"
    },
    d: "M375.2,281.6c59.2,0,107.2,48,107.2,107.2S434.4,496,375.2,496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M299.2,312.8c41.6-41.6,109.6-41.6,152,0c41.6,41.6,41.6,109.6,0,152"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262523"
    },
    d: "M356,437.6c-2.4,0-4-0.8-5.6-2.4l-36-36c-3.2-3.2-3.2-8.8,0-12s8.8-3.2,12,0l29.6,29.6l68.8-68.8 c3.2-3.2,8.8-3.2,12,0s3.2,8.8,0,12l-75.2,75.2C360,436.8,357.6,437.6,356,437.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC117"
    },
    d: "M356,426.4c-2.4,0-4-0.8-5.6-2.4l-36-36c-3.2-3.2-3.2-8.8,0-12s8.8-3.2,12,0l29.6,29.6l68.8-68.8 c3.2-3.2,8.8-3.2,12,0s3.2,8.8,0,12L361.6,424C360,425.6,357.6,426.4,356,426.4z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilingOk);
export default __webpack_public_path__ + "static/media/filing-ok.aed3df4d5ac7be754ed664e67cd032b1.svg";
export { ForwardRef as ReactComponent };